import { observer } from "mobx-react";
import React from "react";
import { Heart } from "react-feather";
import {
  StyledFooter,
  StyledFooterLeft,
  StyledFooterRight,
  StyledFooterNav,
  StyledFotterNavLink,
} from "./style";

const Footer: React.FC = observer(() => {
  return (
    <StyledFooter>
      <StyledFooterRight>
        <StyledFooterNav>
          <StyledFotterNavLink path="https://themeforest.net/licenses/standard">
            Licenses
          </StyledFotterNavLink>
          <StyledFotterNavLink path="/">Change Log</StyledFotterNavLink>
          <StyledFotterNavLink path="https://hasthemes.com/contact-us/">
            Get Help
          </StyledFotterNavLink>
        </StyledFooterNav>
      </StyledFooterRight>
      {/* <StyledFooterLeft></StyledFooterLeft> */}
    </StyledFooter>
  );
});

export default Footer;
